export default __webpack_public_path__ + "static/media/sw5.d533e190.jpg";